// extracted by mini-css-extract-plugin
module.exports = {"focused-sheet":"styles_focused-sheet__ofsOB","focused-sheet__content":"styles_focused-sheet__content__t6gdx","focused-sheet_hidden":"styles_focused-sheet_hidden___3Drs"};